module.exports = __webpack_public_path__ + "img/shareQQSpace.f1367771.png";